export let sampleData = [
    {
        "星期": "周一",
        "迟到人数": 10,
        "忘写日志人数": 12,
        "加班人数": 15,
        "加餐人数": 8,
        "加餐成本": 160
    },
    {
        "星期": "周二",
        "迟到人数": 8,
        "忘写日志人数": 4,
        "加班人数": 25,
        "加餐人数": 16,
        "加餐成本": 300
    },
    {
        "星期": "周三",
        "迟到人数": 5,
        "忘写日志人数": 7,
        "加班人数": 8,
        "加餐人数": 6,
        "加餐成本": 110
    },
    {
        "星期": "周四",
        "迟到人数": 9,
        "忘写日志人数": 3,
        "加班人数": 13,
        "加餐人数": 10,
        "加餐成本": 210
    },
    {
        "星期": "周五",
        "迟到人数": 11,
        "忘写日志人数": 2,
        "加班人数": 5,
        "加餐人数": 4,
        "加餐成本": 100
    }
]